// What a Scenario Center conversation tells the page around it after each send, so the
// page can offer to add the attached files, or what was written, to the scenario.
const SCENARIO_CHAT_PREFIX = "scenario_";
const SCENARIO_CHAT_MESSAGE_KEY = "scenario-chat-message";

export const isScenarioChatId = (chatId) =>
  typeof chatId === "string" && chatId.startsWith(SCENARIO_CHAT_PREFIX);

// The web app pins a scenario's conversation as scenario_<organizationId>_<scenarioId>_<userId>.
// The sidebar knows the organization and the user, so the scenario is what lies between them.
export const scenarioIdFromChatId = ({ chatId, organizationId, userId }) => {
  if (!isScenarioChatId(chatId) || !organizationId || !userId) {
    return null;
  }

  const prefix = `${SCENARIO_CHAT_PREFIX}${organizationId}_`;
  const suffix = `_${userId}`;
  if (!chatId.startsWith(prefix) || !chatId.endsWith(suffix)) {
    return null;
  }

  return chatId.slice(prefix.length, chatId.length - suffix.length) || null;
};

// A file still being read has no base64 yet, and a document the page attached as context
// has none at all: neither is something the person just attached.
const toAttachedFile = ({ name, type, base64 }) => ({ name, type, base64 });
const isAttachedFile = (file) => Boolean(file?.base64) && !file.loading;

export const buildScenarioChatMessage = ({ chatId, text, files }) => {
  if (!isScenarioChatId(chatId)) {
    return null;
  }

  const attachedFiles = (files || [])
    .filter(isAttachedFile)
    .map(toAttachedFile);
  const trimmedText = String(text || "").trim();
  if (!trimmedText && attachedFiles.length === 0) {
    return null;
  }

  return {
    key: SCENARIO_CHAT_MESSAGE_KEY,
    value: { chatId, text: trimmedText, files: attachedFiles },
  };
};

export const notifyScenarioChatMessage = ({
  chatId,
  text,
  files,
  hostWindow = window.parent,
}) => {
  const message = buildScenarioChatMessage({ chatId, text, files });
  if (!message || !hostWindow || hostWindow === window) {
    return false;
  }

  hostWindow.postMessage(message, "*");

  return true;
};
